module.exports = __webpack_public_path__ + "static/media/3622.1582633003.73b9602c.png";